let ctx;
const TONES = {
  fire: [[440, 0], [660, 0.06], [880, 0.12]],
  gg: [[523, 0], [784, 0.09]],
  laugh: [[700, 0], [600, 0.07], [700, 0.14], [600, 0.21]],
  wow: [[300, 0], [900, 0.15]],
  love: [[659, 0], [784, 0.1], [1047, 0.2]],
  wave: [[880, 0], [988, 0.08]],
  badge: [[523, 0], [659, 0.12], [784, 0.24], [1047, 0.36]],
  tick: [[1800, 0]],
  perfect: [[784, 0], [988, 0.08], [1175, 0.16], [1568, 0.26]],
};

export const soundEnabled = () => localStorage.getItem("pz_sound_off") !== "1";
export const setSoundEnabled = (on) => localStorage.setItem("pz_sound_off", on ? "0" : "1");

export function playTone(key) {
  if (!soundEnabled()) return;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    const now = ctx.currentTime;
    (TONES[key] || TONES.fire).forEach(([freq, at]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = key === "wow" ? "sawtooth" : key === "tick" ? "sine" : "triangle";
      osc.frequency.setValueAtTime(freq, now + at);
      if (key === "wow") osc.frequency.exponentialRampToValueAtTime(freq * 1.5, now + at + 0.15);
      gain.gain.setValueAtTime(0.0001, now + at);
      gain.gain.exponentialRampToValueAtTime(key === "tick" ? 0.05 : 0.18, now + at + 0.005);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + at + (key === "tick" ? 0.05 : 0.18));
      osc.connect(gain).connect(ctx.destination);
      osc.start(now + at);
      osc.stop(now + at + 0.2);
    });
  } catch { /* audio unsupported */ }
}
